var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ReservationsAgents"}},[(_vm.reservationsData)?_c('reservations-data-table',{attrs:{"hotelList":_vm.hotelList,"reservations":_vm.reservationsData,"title":_vm.title,"getReservations":_vm.getReservations,"loadingReservations":_vm.loading,"reload":_vm.reload,"filter":_vm.filter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }